import { FC } from "react";
import { Link, Button as IDSButton } from "@smile2impress/components";
import NextLink from "next/link";

import { ButtonProps } from "./ButtonProps.types";

export const Button: FC<ButtonProps> = ({ onClick, link, text, ...rest }) => {
    const linkOnClickHandler = (e: React.MouseEvent<HTMLElement>) => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    return (
        <>
            {/* 
            NextLink can't be passed as as prop because of the issue. 
            Detailed information here: https://github.com/chakra-ui/chakra-ui/discussions/3292
        */}
            {onClick && !link && (
                <IDSButton onClick={onClick} {...rest}>
                    {text}
                </IDSButton>
            )}
            {link && (
                <NextLink href={link} passHref>
                    <IDSButton as={Link} onClick={linkOnClickHandler} {...rest}>
                        {text}
                    </IDSButton>
                </NextLink>
            )}
        </>
    );
};
